import React from 'react';
import PropTypes from 'prop-types';

import 'src/components/SlidesIndicators.scss';
import SlideIndicator from './SlideIndicator';


const SlidesIndicators = ({ count, active, action }) => (
  <div styleName="indicators">
    {new Array(count)
      .fill(null)
      .map((_, index) => {
        const indicatorKey = `dot${index + 1}`;
        return (
          <SlideIndicator key={ indicatorKey } action={ () => action(index) } active={ index === active } />
        );
      })}
  </div>
);


SlidesIndicators.propTypes = {
  action: PropTypes.func.isRequired,
  active: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired
};

export default SlidesIndicators;
